// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-user-menu {
  background-color: var(--g-color-base-float);
  padding: var(--g-spacing-2);
  box-sizing: border-box;
  max-height: calc(100vh - 100px);
  width: 300px;
}
.dl-user-menu__entry {
  box-sizing: border-box;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: var(--g-spacing-2);
  -webkit-text-decoration: none;
  text-decoration: none;
}
.dl-user-menu__entry-content {
  flex: auto;
  min-width: 0;
}
.dl-user-menu__entry-actions {
  white-space: nowrap;
}
.dl-user-menu__entry-button {
  margin-inline-start: var(--g-spacing-1);
}
.dl-user-menu__user {
  display: flex;
}
.dl-user-menu__user-info {
  font-family: var(--g-text-body-font-family);
  font-weight: var(--g-text-body-font-weight);
  font-size: var(--g-text-body-short-font-size);
  line-height: var(--g-text-body-short-line-height);
  display: flex;
  flex: auto;
  flex-direction: column;
  min-width: 0;
  margin-left: var(--g-spacing-3);
  align-items: flex-start;
  justify-content: center;
}
.dl-user-menu__user-name, .dl-user-menu__user-description {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}
.dl-user-menu__user-description {
  color: var(--g-color-text-secondary);
}
.dl-user-menu__user-avatar {
  flex-shrink: 0;
}
.dl-user-menu__user-label {
  margin-top: var(--g-spacing-1);
  width: auto;
  max-width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/UserMenu/UserMenu.scss","webpack://./node_modules/@gravity-ui/uikit/styles/mixins.scss"],"names":[],"mappings":"AAEA;EACI,2CAAA;EACA,2BAAA;EACA,sBAAA;EACA,+BAAA;EACA,YAAA;AADJ;AAGI;EACI,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,2BAAA;EACA,6BAAA;EAAA,qBAAA;AADR;AAII;EACI,UAAA;EACA,YAAA;AAFR;AAKI;EACI,mBAAA;AAHR;AAMI;EACI,uCAAA;AAJR;AAOI;EACI,aAAA;AALR;AAQI;ECyJA,2CAAA;EACA,2CAAA;EACA,6CAAA;EACA,iDAAA;ED1JI,aAAA;EACA,UAAA;EACA,sBAAA;EACA,YAAA;EACA,+BAAA;EACA,uBAAA;EACA,uBAAA;AAHR;AAMI;EC1CA,mBAAA;EACA,gBAAA;EACA,uBAH4B;ED8CxB,eAAA;AAHR;AAMI;EACI,oCAAA;AAJR;AAOI;EACI,cAAA;AALR;AAQI;EACI,8BAAA;EACA,WAAA;EACA,eAAA;AANR","sourcesContent":[".dl-user-menu {\n  background-color: var(--g-color-base-float);\n  padding: var(--g-spacing-2);\n  box-sizing: border-box;\n  max-height: calc(100vh - 100px);\n  width: 300px;\n}\n.dl-user-menu__entry {\n  box-sizing: border-box;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: var(--g-spacing-2);\n  text-decoration: none;\n}\n.dl-user-menu__entry-content {\n  flex: auto;\n  min-width: 0;\n}\n.dl-user-menu__entry-actions {\n  white-space: nowrap;\n}\n.dl-user-menu__entry-button {\n  margin-inline-start: var(--g-spacing-1);\n}\n.dl-user-menu__user {\n  display: flex;\n}\n.dl-user-menu__user-info {\n  font-family: var(--g-text-body-font-family);\n  font-weight: var(--g-text-body-font-weight);\n  font-size: var(--g-text-body-short-font-size);\n  line-height: var(--g-text-body-short-line-height);\n  display: flex;\n  flex: auto;\n  flex-direction: column;\n  min-width: 0;\n  margin-left: var(--g-spacing-3);\n  align-items: flex-start;\n  justify-content: center;\n}\n.dl-user-menu__user-name, .dl-user-menu__user-description {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n}\n.dl-user-menu__user-description {\n  color: var(--g-color-text-secondary);\n}\n.dl-user-menu__user-avatar {\n  flex-shrink: 0;\n}\n.dl-user-menu__user-label {\n  margin-top: var(--g-spacing-1);\n  width: auto;\n  max-width: 100%;\n}",null],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
